import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const ReductionPage: FC = () => {  
    return (
        <Outlet />
    );
}

export default ReductionPage